import React, { useState } from "react"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

//COMPONENTS
import CustomButton from "components/Buttons/custom"
import HeaderWithIcon from "components/Header/withIcon"

//DEPENDENCIES
import Column from "./Column"
import Filter from "componentsV3/Filter/menuFilter";

//REDUX
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as reduxActions from "store/actions"
import reduxStore from "store/"


//STYLE
import "./style.css"


//FUNCTIONS
import { getKanbanData, addColumn, reorder, automation } from "functions/kanban"
import { getUserAccess } from "functions/cards"
import { customApp, translate, getAppAccess } from "functions"


function reorderList(list, startIndex, endIndex) {
    const result = Array.from(list);
    // return result.splice(startIndex, 1, list[endIndex]);
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
}

function AgileKanban(props) {
    const [state, setState] = useState(getKanbanData(props.nodeId, { deleted: false }, props.cards))
    const [orderBy, setOrderBy] = useState('order')
    const [deleted, setDeleted] = useState(false)
    const [addColumnActive, setAddColumn] = useState(false)
    // const [dragActive, setDragActive] = useState(false)

    const AppAccess = getAppAccess()
    const CardAccess = getUserAccess(props.nodeId)
    const controls = React.useRef({
        lock: false,
        updateCards: false
    })

    const updateCards = () => {
        setState(getKanbanData(props.nodeId, {
            deleted: deleted,
            orderBy
        }))
    }

    React.useEffect(() => {
        if (!controls.current.lock) {
            updateCards()
        }
    }, [props.cards, props.nodeId, props.searchs])


    async function onDragEnd(result) {
        controls.current = {
            ...controls.current,
            lock: false
        }
        // setDragActive(false)
        if (!result.destination) {
            return
        }
        // console.log(result.type)
        if (result.type === "column") {
            if (CardAccess < 5)
                return
            const columnOrder = reorderList(
                state.columnOrder,
                result.source.index,
                result.destination.index
            )
            let newColumnOrder = {}
            columnOrder.forEach((id, orderI) => {
                newColumnOrder = {
                    ...newColumnOrder,
                    [id]: {
                        ...reduxStore.getState().db.cards[id],
                        step: `${(orderI)}`
                    }
                }
            })
            props.reduxFunction("ASYNC", "SET_DB", {
                ...reduxStore.getState().db,
                cards: {
                    ...reduxStore.getState().db.cards,
                    ...newColumnOrder
                }
            })

            let cardSource = reduxStore.getState().db.cards[columnOrder[result.source.index]]
            let cardTarget = reduxStore.getState().db.cards[columnOrder[result.destination.index]]
            if (
                cardSource
                && (
                    cardSource.showInPanel
                    || cardSource.onConcludedStepMoveTo
                )
            ) return

            if (
                cardTarget
                && (
                    cardTarget.showInPanel
                    || cardTarget.onConcludedStepMoveTo
                )
            ) return

            if (JSON.stringify(columnOrder) !== JSON.stringify(state.columnOrder))
                reorder(columnOrder, 'step')
            return
        }

        const sourceColumn = state.columns[result.source.droppableId]
        const item = sourceColumn.items[result.source.index]


        //LINK
        let parentCard = reduxStore.getState().db.cards[result.destination.droppableId]
        let card = reduxStore.getState().db.cards[sourceColumn.items[result.source.index]._id]
        const { session } = reduxStore.getState()

        if (
            parseInt(parentCard.step) >= parseInt(reduxStore.getState().db.cards[result.source.droppableId].step)
            &&
            (card._requireApproval &&
                (
                    card._users
                    && card._users[session._id]
                    && !card._users[session._id].approvalResponsible
                )
            )
        ) return
        if (result.source.droppableId === result.destination.droppableId) {
            const items = Array.from(reorderList(
                state.columns[result.source.droppableId].items,
                result.source.index,
                result.destination.index
            ))

            let newCardsOrder = {}
            let cardsOrder = []
            console.log(items)
            items
                // .sort((ca, cb) => {
                //     let orderA = 0
                //     let orderB = 0
                //     if (ca?.order)
                //         orderA = String(ca?.order?.low ? ca?.order?.low : ca?.order)
                //     if (cb?.order)
                //         orderB = String(cb?.order?.low ? cb?.order?.low : cb?.order)
                //     if (parseInt(orderA) < parseInt(orderB))
                //         return -1
                //     if (parseInt(orderA) > parseInt(orderB))
                //         return 1
                //     return 0
                // })
                .forEach((card, orderI) => {
                    console.log(card.name)
                    newCardsOrder = {
                        ...newCardsOrder,
                        [card._id]: {
                            ...reduxStore.getState().db.cards[card._id],
                            order: `${(orderI)}`
                        }
                    }
                    if (cardsOrder.indexOf(card._id) === -1)
                        cardsOrder.push(card._id)
                })
            props.reduxFunction("ASYNC", "SET_DB", {
                ...reduxStore.getState().db,
                cards: {
                    ...reduxStore.getState().db.cards,
                    ...newCardsOrder
                }
            })

            reorder(cardsOrder, 'order')

            return
        }



        if (
            parseInt(parentCard.step) > parseInt(reduxStore.getState().db.cards[result.source.droppableId].step)
            &&
            (card._requireApproval &&
                (
                    card._users
                    && card._users[session._id]
                    && !card._users[session._id].approvalResponsible
                )
            )
        ) return

        let dataUpdate = automation(props, card?._id || null, parentCard?._id || null, card?._createdBy?._id || null)
        if (parentCard.requireApproval) {
            dataUpdate = {
                ...dataUpdate,
                _requireApproval: true
            }
        } else if (!parentCard.requireApproval && item._requireApproval) {
            dataUpdate = {
                ...dataUpdate,
                _requireApproval: null
            }
        }

        props.reduxFunction("ASYNC", "SET_DB", {
            ...reduxStore.getState().db,
            cards: {
                ...reduxStore.getState().db.cards,
                [item._id]: {
                    ...reduxStore.getState().db.cards[item._id],
                    ...dataUpdate,
                    _parent: result.destination.droppableId,
                }
            }
        })
    }

    const newColumn = async (data) => {
        let response = await addColumn(data)
        if (response) {
            props.reduxFunction("ASYNC", "SET_DB", {
                ...reduxStore.getState().db,
                cards: {
                    ...reduxStore.getState().db.cards,
                    ...response
                }
            })
        }
    }

    return (
        <DragDropContext
            // onBeforeCapture={(e) => {
            //     console.log('onBeforeCapture', e)
            // }}
            onBeforeDragStart={(e) => {
                controls.current = {
                    ...controls.current,
                    lock: true
                }
                console.log(e)
            }}
            // onDragUpdate={(e) => {
            //     console.log('onDragUpdate', e)
            // }}
            // onDragStart={(e) => {
            //     console.log('onDragStart', e)
            //     // setDragActive(true)
            // }}
            onDragEnd={onDragEnd}
        >
            <div
                className="app"
                style={{
                    overflowY: "auto",
                    height: "-webkit-fill-available",
                    paddingTop: 50
                }}
            >
                <Droppable
                    droppableId="all-droppables"
                    direction="horizontal"
                    type="column"
                >
                    {provided => (
                        <div
                            {...provided.droppableProps}
                            className="columns"
                            ref={provided.innerRef}
                        >
                            {state.columnOrder.map((columnId, index) => (
                                <Column
                                    {...props}
                                    key={columnId}
                                    column={state.columns[columnId]}
                                    index={index}
                                    nodeId={props.nodeId}
                                    {...props.columProps ? props.columProps : {}}
                                />
                            ))}
                            {(
                                (
                                    AppAccess.admin
                                    && AppAccess.planAdmin
                                )
                                ||
                                CardAccess > 3
                            ) ?
                                <div className="column"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    {!addColumnActive ?
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#FFFFFF",
                                                color: "black",
                                                padding: 15,
                                                width: 279
                                            }}
                                        >
                                            <div id="AgileKanbanIndex_256">
                                                <CustomButton
                                                    title={translate("$__addColumn")}
                                                    text={translate("$__addColumn")}
                                                    color={"lightgrey"}
                                                    textColor={"lightgrey"}
                                                    icon={"add_box"}
                                                    onClick={() => {
                                                        setAddColumn(true)
                                                    }}

                                                    size={"25px"}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#FFFFFF",
                                                width: 279,
                                                padding: 7
                                            }}
                                        >
                                            <div id="AgileKanbanIndex_282">
                                                <HeaderWithIcon
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                    title={null}
                                                    color={customApp('menu')}
                                                    editable
                                                    permitIcon
                                                    onEdit={(e) => {
                                                        setAddColumn(false)
                                                        newColumn({
                                                            ...e,
                                                            _parent: props.nodeId,
                                                            type: "step",
                                                            step: String(state.columnOrder.length),
                                                            checklist: true
                                                        })
                                                    }}
                                                    placeholder={translate("$__columnName")}
                                                    onCancel={() => { setAddColumn(false) }}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                                : <React.Fragment></React.Fragment>
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

            </div>
            <div
                style={{
                    position: "absolute",
                    top: 15,
                    left: 15,
                    height: "50px",
                    width: "50px",
                }}
            >
                <Filter
                    nodeId={props.nodeId}
                    fields={['text', 'date', 'tags', 'status', 'priority', 'impact', 'risk', 'complexity', 'users']}
                    showFilters
                />
            </div>
        </DragDropContext>
    )
}

const mapStateToProps = (store, props) => {
    return ({
        cards: store.db.cards,
        cardsExpanded: store.db.cardsExpanded,
    })
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(reduxActions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AgileKanban)